import { makeObservable, observable, computed, action } from 'mobx';

import { apiHost,erpApiurl } from './APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Receivables. The Service is unavailable. Please try after sometime." };

export default class ReceivableStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    receivables = [];
    rowCount = 0;
    totalReceivableSum = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.collectionType = props.collectionType;

        makeObservable(this, {
            state: observable,
            message: observable,
            receivables: observable,
            rowCount: observable,
            totalReceivableSum: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchReceivableSummary: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

   
    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchReceivableSummary = async () => {
    
        const url = `${erpApiurl}api/Carbon/GetLabBillSummary?collectionType=${this.collectionType}`;
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }

            this.receivables = data;
            this.rowCount = data.length;
            this.totalReceivableSum = 0;
            data.map((receivable) =>
                this.totalReceivableSum = this.totalReceivableSum + receivable.Total      
            );
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }
}
